module.exports = __webpack_public_path__ + "static/media/mikko_seppanen_2_netti.cb5da933.jpg";